<template>
  <div>
    <page :loading="isLoading">
      <rest-list :payload="listEndpoint">
        <template>
          <rest-list-column-date
            prop="create_time"
            :title="$t('TaskHistoryList_Field_CreateTime')"
            :width="200"
          />
          <rest-list-column-enum
            prop="identifier"
            :title="$t('Audiences_SegmentEvaluations_TitleCol')"
            :enum="evaluateIdentifierLabel"
          />
          <rest-list-column-enum
            prop="status"
            :title="$t('TaskHistoryList_Field_Status')"
            :enum="statusLabel"
          />
          <rest-list-column-single-action>
            <template slot-scope="scope">
              <i
                class="el-icon-view"
                @click="fetchTaskData(scope.row.id)"
                v-if="
                  scope.row.status === statusEnum.DONE &&
                    (scope.row.identifier ===
                      'segment_shared_count_recipients' ||
                      scope.row.identifier === 'segment_shared_count_channels')
                "
              />
              <i
                class="el-icon-view"
                @click="fetchTaskData(scope.row.id)"
                v-if="
                  scope.row.status === statusEnum.DONE &&
                    scope.row.identifier ===
                      'segment_shared_preview_recipients' &&
                    $can('UserPersonalData::Read')
                "
              />
              <i
                class="el-icon-view"
                @click="fatal = true"
                v-if="scope.row.status === statusEnum.FATAL"
              />
              <i
                class="el-icon-view"
                @click="error = true"
                v-if="scope.row.status === statusEnum.ERROR"
              />
              <i
                class="el-icon-download"
                @click="downloadExport(scope.row)"
                v-if="
                  scope.row.status === statusEnum.DONE &&
                    $can('UserPersonalData::Export') &&
                    (scope.row.identifier === 'segment_shared_export_devices' ||
                      scope.row.identifier === 'segment_shared_export_profiles')
                "
              />
            </template>
          </rest-list-column-single-action>
        </template>
      </rest-list>
      <fatal-dialog v-if="fatal" />
      <error-dialog v-if="error" />
    </page>
  </div>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import { baseUrl, projectEndpoint } from '@/core/helpers'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import {
  evaluateTaskIdentifierLabel as evaluateIdentifierLabel,
  taskStatusEnum as statusEnum,
  taskStatusLabel as statusLabel
} from '@/modules/tasks/enum/TaskRecordEnums'
import RestListColumnSingleAction from '@/common/components/rest/RestListColumnSingleAction'
import RestApi from '@/core/services/RestApi'
import { EventBus } from '@/core/EventBus'
import moment from 'moment'
import Page from '@/common/components/page/Page'
import axios from 'axios'
import FatalDialog from '@/modules/audiences/components/FatalDialog'
import ErrorDialog from '@/modules/audiences/components/ErrorDialog'

export default {
  name: 'SharedSegmentEvaluations',
  components: {
    ErrorDialog,
    FatalDialog,
    Page,
    RestListColumnSingleAction,
    RestList,
    RestListColumnEnum,
    RestListColumnDate
  },
  mounted() {
    EventBus.$on('fatal-ok', () => {
      this.fatal = false
    })
    EventBus.$on('error-ok', () => {
      this.error = false
    })
  },
  destroyed() {
    EventBus.$off('fatal-ok')
    EventBus.$off('error-ok')
  },
  data() {
    return {
      statusEnum,
      evaluateIdentifierLabel,
      statusLabel,
      taskData: null,
      isLoading: false,
      fatal: false,
      error: false
    }
  },
  methods: {
    downloadExport(task) {
      let url = `${baseUrl()}file/private/download?id=${task.task.file.id}`
      let label = `${task.task.file.name}.csv`
      axios
        .get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = label
          link.click()
          URL.revokeObjectURL(link.href)
          this.onClose()
        })
        .catch(console.error)
    },
    resetTaskData() {
      this.taskData = false
    },
    taskEndpoint() {
      projectEndpoint({
        method: 'get',
        url: `task-histories/${this.$route.query.id}?expand=task`
      })
    },
    fetchTaskData(taskId) {
      this.isLoading = true
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `task-histories/${taskId}?expand=task`
        })
      )
        .then(({ data }) => {
          this.isLoading = false
          this.taskData = data
        })
        .catch(error => {
          this.isLoading = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  },
  computed: {
    dateCreated() {
      return this.taskData
        ? moment(this.taskData.create_time * 1000).format('DD-MMM-YYYY HH:mm')
        : null
    },
    listEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `task-histories`,
        params: {
          sort: '-create_time',
          shared_segment_id: this.$route.query.id,
          expand: 'task'
        }
      })
    }
  }
}
</script>
<style scoped>
.el-icon-view,
.el-icon-download {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SharedSegmentTabEvaluations.vue